module.exports = __webpack_public_path__ + "static/media/Hospitality_64.79490619.jpg";